import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-preset-warning-dialog',
  templateUrl: './preset-warning-dialog.component.html',
  styleUrls: ['./preset-warning-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PresetWarningDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PresetWarningDialogComponent>,) {
  }

  public ngOnInit(): void {
  }

  public proceed(persistOverrides: boolean): void {
    this.dialogRef.close(persistOverrides);
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }
}
